import React from "react";

const LoadingSpinner = () => {
  const spinnerStyle = {
    border: ".5rem solid #f3f3f3",
    borderTop: ".5rem solid #3498db",
    borderRadius: "50%",
    width: "3rem",
    height: "3rem",
    animation: "spin 2s linear infinite",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  };

  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  };

  const keyframes = `
        @keyframes spin {
            0% { transform: translate(-50%, -50%) rotate(0deg); }
            100% { transform: translate(-50%, -50%) rotate(360deg); }
        }
    `;

  return (
    <div style={containerStyle}>
      <div style={spinnerStyle}>
        <style>{keyframes}</style>
      </div>
    </div>
  );
};

export default LoadingSpinner;
